<template>
  <div class="container" ref="containerRef">
    <div class="search-box" ref="searchBoxRef">
      <div class="search-form">
        <el-form :inline="true">
          <!-- 客户名称、供应商名称、订单号、订单状态、结算状态、缴费状态、下单时间、完成收货时间 -->
          <el-form-item>
            <el-input
              v-model="payShopName"
              style="width: 120px"
              size="small"
              placeholder="客户名称"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item>
            <el-input
              v-model="supplierName"
              style="width: 120px"
              size="small"
              placeholder="供应商名称"
            ></el-input>
          </el-form-item> -->
          <el-form-item>
            <!-- 客户类型 -->
            <mutilSelect
              :ids.sync="clientIds"
              type="customer"
              title="客户类型"
            ></mutilSelect>
          </el-form-item>
          <el-form-item>
            <!-- 供应商名称 -->
            <mutilSelect
              :ids.sync="supplierIds"
              type="supplier"
              title="供应商名称"
            ></mutilSelect>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="orderCode"
              style="width: 160px"
              size="small"
              placeholder="订单编号"
            ></el-input>
          </el-form-item>
          <!-- 订单状态 -->
          <el-form-item>
            <el-select
              v-model="orderStatus"
              style="width: 160px"
              size="small"
              placeholder="订单状态"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="(item, index) in statusArr"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 结算状态 -->
          <el-form-item>
            <el-select
              v-model="settleAccountsStatus"
              style="width: 160px"
              size="small"
              placeholder="结算状态"
            >
              <el-option label="已结算" value="1"></el-option>
              <el-option label="未结算" value="0"></el-option>
            </el-select>
          </el-form-item>
          <!-- 缴费状态 -->
          <el-form-item>
            <el-select
              v-model="payFeesStatus"
              style="width: 160px"
              size="small"
              placeholder="缴费状态"
            >
              <el-option label="未缴费" value="0"></el-option>
              <el-option label="已缴费" value="1"></el-option>
            </el-select>
          </el-form-item>
          <!-- 下单时间 时间区间-->
          <el-form-item label="下单时间">
            <el-date-picker
              placeholder="选择日期"
              v-model="orderDate"
              format="yyyy-MM-dd HH:mm:ss"
              size="small"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="完成收货时间">
            <el-date-picker
              placeholder="选择日期"
              v-model="finishDate"
              format="yyyy-MM-dd HH:mm:ss"
              size="small"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="search-btn">
        <el-button type="primary" size="small" @click="handleSearch"
          >搜索</el-button
        >
        <el-button size="small" @click="handleReset">重置</el-button>
        <el-button type="primary" size="small" @click="handleExport"
          >导出</el-button
        >
      </div>
    </div>
    <priceTotalNotice :count="noticeCount" :list="noticeArr"></priceTotalNotice>
    <div class="table-box">
      <!-- 下单时间 完成收货时间 订单编号 订单状态 订单总金额（元）分账金额（元）应收总金额（元）收入技术服务费（元）收入推广服务费（元）客户名称 运费（元）平台补贴（元） 售后总金额（元） 订单技术服务费（元） 订单推广服务费（元） 结算金额（元）供应商名称 供应商税号 供应商地址 供应商电话 供应商开户银行 供应商银行账号 供应商联系人 供应商联系电话 结算状态 缴费状态 -->
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        ref="tableBoxRef"
        :height="tableBoxHeight"
        v-loading="loading"
      >
        <template v-for="(item, index) in tableColumns">
          <el-table-column
            v-if="item.slot"
            :key="index"
            :label="item.label"
            :width="item.width"
            :align="item.align"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span v-if="item.prop === 'orderStatus'">{{
                orderStatusMap[scope.row.orderStatus]
              }}</span>
              <span v-if="item.prop === 'settleAccountsStatus'">{{
                settleAccountsStatusMap[scope.row.settleAccountsStatus]
              }}</span>
              <span v-if="item.prop === 'payFeesStatus'">{{
                payFeesStatusMap[scope.row.payFeesStatus]
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :align="item.align"
            :show-overflow-tooltip="true"
            v-else
          >
          </el-table-column>
        </template>
      </el-table>
    </div>
    <div class="pagination-box" v-if="tableData.length > 0">
      <el-pagination
        layout="prev, pager, next , jumper, sizes, total"
        :total="page.total"
        :page-size="page.size"
        :current-page="page.current"
        background
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
        :page-sizes="[20, 50, 100]"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import {
  orderBbillsPlatformPage,
  orderBbillsPlatformCollect,
  orderBbillsPlatformExport,
} from "@/api/saleRule/agent";
import mutilSelect from "@/views/financialcenter/components/mutilSelect.vue";
import priceTotalNotice from "@/components/priceTotalNotice";
export default {
  name: "plOrderStatementOfAccount",
  components: {
    mutilSelect,
    priceTotalNotice,
  },
  data() {
    return {
      containerRef: null,
      searchBoxRef: null,
      tableBoxRef: null,
      tableBoxHeight: 200,
      payShopName: "",
      supplierName: "",
      orderCode: "",
      orderStatus: "",
      settleAccountsStatus: "",
      payFeesStatus: "",
      orderDate: "",
      finishDate: "",
      loading: false,
      statusArr: [
        { value: "", label: "全部" },
        { value: "2", label: "待发货" },
        { value: "3", label: "配送中" },
        { value: "5", label: "已取消" },
        { value: "8", label: "已收货" },
        { value: "9", label: "已完成" },
        { value: "12", label: "待确款" },
      ],
      page: {
        current: 1,
        size: 20,
        total: 0,
      },
      // 订单状态：1.待付款,2.待发货, 3.配送中,4.资质待审核,5.交易取消, 6申请退款,7.已退款,8.已签收, 9.已完成, 00.不展示订单,11-订单待审核,10-待确款
      orderStatusMap: {
        1: "待付款",
        2: "待发货",
        3: "配送中",
        4: "已完成",
        5: "交易取消",
        6: "申请退款",
        7: "已退款",
        8: "已收货",
        9: "已完成",
        "00": "不展示订单",
        11: "订单待审核",
        12: "待确款",
      },
      // 结算状态:0未结算1已结算
      settleAccountsStatusMap: {
        0: "未结算",
        1: "已结算",
      },
      // 缴费状态:0未支付1已支付
      payFeesStatusMap: {
        0: "未缴费",
        1: "已缴费",
      },
      tableColumns: [
        {
          width: 150,
          align: "center",
          label: "客户名称",
          prop: "payShopName",
        },
        {
          width: 100,
          align: "center",
          label: "客户类型",
          prop: "typeName",
        },
        {
          width: 150,
          align: "center",
          label: "商品总金额（元）",
          prop: "orderTotalPrice",
        },
        {
          width: 150,
          align: "center",
          label: "分账金额（元）",
          prop: "splitAccountPrice",
        },
        {
          width: 150,
          align: "center",
          label: "应收总金额（元）",
          prop: "plmReceivableTotalPrice",
        },
        {
          width: 200,
          align: "center",
          label: "收入技术服务费（元）",
          prop: "platformServiceMoney",
        },
        {
          width: 200,
          align: "center",
          label: "收入推广服务费（元）",
          prop: "promotionMoney",
        },

        {
          width: 150,
          align: "center",
          label: "运费（元）",
          prop: "freightPrice",
        },
        {
          width: 150,
          align: "center",
          label: "平台补贴（元）",
          prop: "platformSubsidyPrice",
        },
        {
          width: 150,
          align: "center",
          label: "平台代金券（元）",
          prop: "subsidyAmount",
        },
        {
          width: 150,
          align: "center",
          label: "售后总金额（元）",
          prop: "refundAmount",
        },
        {
          width: 200,
          align: "center",
          label: "订单技术服务费（元）",
          prop: "orderPlatformServiceMoney",
        },
        {
          width: 200,
          align: "center",
          label: "订单推广服务费（元）",
          prop: "orderPromotionMoney",
        },
        {
          width: 200,
          align: "center",
          label: "订单结算金额（元）",
          prop: "settlementMoney",
        },
        {
          width: 100,
          align: "center",
          label: "供应商名称",
          prop: "supplierName",
        },
        {
          width: 100,
          align: "center",
          label: "供应商税号",
          prop: "supplierDutyNumber",
        },
        {
          width: 100,
          align: "center",
          label: "供应商地址",
          prop: "supplierAddress",
        },
        {
          width: 100,
          align: "center",
          label: "供应商电话",
          prop: "supplierPhone",
        },
        {
          width: 160,
          align: "center",
          label: "供应商开户银行",
          prop: "supplierOpeningBank",
        },
        {
          width: 160,
          align: "center",
          label: "供应商银行账号",
          prop: "supplierBankAccount",
        },
        {
          width: 100,
          align: "center",
          label: "供应商联系人",
          prop: "supplierContactPerson",
        },
        {
          width: 200,
          align: "center",
          label: "供应商联系电话",
          prop: "supplierContactNumber",
        },
        {
          width: 100,
          align: "center",
          label: "结算状态",
          prop: "settleAccountsStatus",
          slot: true,
        },
        {
          width: 100,
          align: "center",
          label: "缴费状态",
          prop: "payFeesStatus",
          slot: true,
        },
        {
          width: 160,
          align: "center",
          label: "下单时间",
          prop: "orderTime",
        },
        {
          width: 160,
          align: "center",
          label: "完成收货时间",
          prop: "finishDate",
        },
        {
          width: 160,
          align: "center",
          label: "订单编号",
          prop: "orderCode",
        },
        {
          width: 100,
          align: "center",
          label: "订单状态",
          prop: "orderStatus",
          slot: true,
        },
      ],
      tableData: [],
      supplierIds: [], // 供应商id
      clientIds: [], // 客户id
      noticeArr: [],
      noticeCount: 0,
    };
  },
  created() {
    this.requestData();
    // 查询高度
    this.$nextTick(() => {
      const containerHeight = this.$refs.containerRef.offsetHeight;
      const searchBoxHeight = this.$refs.searchBoxRef.offsetHeight;
      this.tableBoxHeight =
        containerHeight - searchBoxHeight - 12 - 12 - 35 - 24;
    });
  },
  methods: {
    getSummaryMethod({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = `共 ${data.length} 笔订单`; // 可以自定义合计行的名称
          return;
        }
        // 把 以下 计算合计
        // 订单总金额 售后总金额 订单技术服务费 订单推广服务费
        if (
          column.property === "orderTotalPrice" ||
          column.property === "refundAmount" ||
          column.property === "orderPlatformServiceMoney" ||
          column.property === "orderPromotionMoney"
        ) {
          const values = data.map((item) => Number(item[column.property])); // 获取每列的值
          sums[index] = values
            .reduce((prev, curr) => Number(prev) + Number(curr), 0)
            .toFixed(2); // 计算合计值并格式化输出
          return;
        }
      });
      return sums;
    },
    countNotices(item) {
      const {
        total = 0,
        orderTotalPrice = 0,
        refundAmount = 0,
        orderPlatformServiceMoney = 0,
        orderPromotionMoney = 0,
      } = item;
      // 订单总金额 售后总金额 订单技术服务费 订单推广服务费
      try {
        const sums = {
          orderTotalPrice: 0,
          refundAmount: 0,
          orderPlatformServiceMoney: 0,
          orderPromotionMoney: 0,
        };
        this.noticeCount = Number(total);
        sums.orderTotalPrice = orderTotalPrice;
        sums.refundAmount = refundAmount;
        sums.orderPlatformServiceMoney = orderPlatformServiceMoney;
        sums.orderPromotionMoney = orderPromotionMoney;
        this.noticeArr = Object.entries(sums).map(([key, value]) => {
          const titles = {
            orderTotalPrice: "订单总金额",
            refundAmount: "售后总金额",
            orderPlatformServiceMoney: "订单技术服务费",
            orderPromotionMoney: "订单推广服务费",
          };
          return {
            title: titles[key],
            price: value.toFixed(2),
          };
        });
      } catch (error) {
        console.error("计算总金额时发生错误:", error);
      }
    },
    pendingParams() {
      const obj = {
        current: this.page.current,
        size: this.page.size,
        payShopName: this.payShopName,
        supplierName: this.supplierName,
        orderCode: this.orderCode,
        orderStatus: this.orderStatus,
        settleAccountStatus: this.settleAccountsStatus,
        payFeeStatus: this.payFeesStatus,
        typeCode: this.clientIds,
        supplierIds: this.supplierIds,
      };
      if (this.orderDate && this.orderDate.length > 0) {
        obj.orderStartTime = dayjs(this.orderDate[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        obj.orderEndTime = dayjs(this.orderDate[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      if (this.finishDate && this.finishDate.length > 0) {
        obj.finishStartTime = dayjs(this.finishDate[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        obj.finishEndTime = dayjs(this.finishDate[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      return obj;
    },
    // 请求数据
    requestData() {
      // loading
      // const loading = this.$loading({
      //   lock: true,
      //   text: "加载中...",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });
      this.loading = true;
      const obj = this.pendingParams();
      orderBbillsPlatformPage(obj)
        .then((res) => {
          const { records, total, current } = res;
          this.tableData = records || [];
          this.page.total = total || 0;
          this.page.current = current || 1;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          // loading.close();
          this.loading = false;
        });
      orderBbillsPlatformCollect(obj)
        .then((res) => {
          if (res) {
            this.countNotices(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 搜索
    handleSearch() {
      console.log(
        this.payShopName,
        this.supplierName,
        this.orderCode,
        this.orderStatus,
        this.settleAccountsStatus,
        this.payFeesStatus,
        this.orderDate,
        this.finishDate
      );
      this.page.current = 1;
      this.requestData();
    },
    // 重置
    handleReset() {
      this.payShopName = "";
      this.supplierName = "";
      this.orderCode = "";
      this.orderStatus = "";
      this.settleAccountsStatus = "";
      this.payFeesStatus = "";
      this.orderDate = "";
      this.finishDate = "";
      this.page.current = 1;
      this.page.size = 20;
      this.clientIds = [];
      this.supplierIds = [];
      this.requestData();
    },
    // 导出
    handleExport() {
      const obj = this.pendingParams();
      orderBbillsPlatformExport(obj)
        .then((res) => {
          const { data } = res;
          if (data && data.size) {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", "订单对账单.xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 分页
    handlePageChange(page) {
      this.page.current = page;
      this.requestData();
    },
    handleSizeChange(size) {
      this.page.size = size;
      this.page.current = 1;
      this.requestData();
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  background-color: #ffffff;
  padding: 12px;
  overflow-y: auto;
  .search-box {
    display: flex;
    align-items: center;
    .search-form {
      display: flex;
      flex: 1;
    }
    .search-btn {
      width: 200px;
    }
  }
  .table-box {
    display: flex;
    flex: 1;
    .el-table {
      width: 100%;
    }
  }
  .pagination-box {
    text-align: center;
  }
}
</style>
